import { ReactElement } from 'react';

import { StyledFlex } from '@dreryk/react-components';
import { dateTimeMinuteFormatter, patientNameFormatter, Translate } from '@dreryk/react-common';

import { systemActivityTranslationKeys } from '../../translations';

import { StyledResourceTypeCellSecondaryText } from './ResourceTypeCell.styled';
import { ConfidentialResourceAccessRequestSingle } from './ResourceTypeCell.types';

type ResourceTypeCellProps = {
   confidentialResourceAccessRequest: ConfidentialResourceAccessRequestSingle;
};

export const ResourceTypeCell = (props: ResourceTypeCellProps): ReactElement => {
   const { confidentialResourceAccessRequest } = props;
   const [confidentialResource] = confidentialResourceAccessRequest.confidentialResources;

   return (
      <StyledFlex direction={'column'}>
         {confidentialResourceAccessRequest.resourceType === 'PATIENT_MEDICAL_DOCUMENTATION' ? (
            <Translate>
               {systemActivityTranslationKeys.resourceTypeMap[confidentialResourceAccessRequest.resourceType]}
            </Translate>
         ) : (
            <span>{confidentialResource.resourceName}</span>
         )}
         <StyledResourceTypeCellSecondaryText>
            {dateTimeMinuteFormatter(confidentialResource.creationDate)}
         </StyledResourceTypeCellSecondaryText>
         <StyledResourceTypeCellSecondaryText>
            {patientNameFormatter(confidentialResourceAccessRequest.patient)}
         </StyledResourceTypeCellSecondaryText>
      </StyledFlex>
   );
};
